/* eslint-disable */
/**
 * The path of the `AccountsPage` to be consumed by a `<Router />`
 * @export
 */
export const ACCOUNTS_PAGE_PATH = `/accounts`;

/**
 * Create a `href` that will resolve to `AccountsPage`
 * @export
 * @returns {string} The `ACCOUNTS_PAGE_PATH`
 */
export const createAccountsPageLink = () => ACCOUNTS_PAGE_PATH;

/**
 * Determine if the current page is the `AccountsPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `AccountsPage`
 */
export const isAccountsPage = (match) => match.path === ACCOUNTS_PAGE_PATH;
